import styled from 'styled-components';

import TextInput from 'components/TextInput';
import CheckBox from 'components/CheckBox';

export const RegisterPanel = styled.div`
	min-width: 940px;
`;

export const FormContain = styled.div``;

export const InputContain = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`;

export const FormInput = styled(TextInput)`
	flex: unset;
	margin-bottom: 16px;
	width: 100%;
`;

export const FormCheckBox = styled(CheckBox)``;

export const Container = styled.div``;
